export const classes = {
  paper: 'w-[90vw] max-w-[600px]',
  wrapper: 'flex flex-col min-h-0',
  inputBase:
    'w-full flex-0 px-6 py-4 text-2xl text-taupe-3 dark:text-mauve-1 placeholder:text-taupe-1 dark:placeholder:text-mauve-3',
  divider: 'mx-[14px] h-px bg-black/10 dark:bg-white/10',
  title:
    'px-4 pt-3 text-xs font-semibold uppercase tracking-wide text-taupe-1 dark:text-mauve-3',
  resultsList: 'flex-0 max-h-[40vh] overflow-auto mb-4',
};
